export default "__VITE_ASSET__CEaoCveX__"